import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LocalDataServiceService {

  constructor() { }

  getHeaders() {
    return new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer '+ this.getToken(),
      'Access-Control-Allow-Origin': '*'
    });
  }
  emailHeaders() {
    return new HttpHeaders({
      'Authorization': 'Bearer '+ this.getToken(),
      'Access-Control-Allow-Origin': '*'
    });
  }

  deleteHeaders() {
    return new HttpHeaders({
      'DELETE_TOKEN': '32d6173cb75af23e143ff67b9732e267'
    });
  }

getToken() {
    return localStorage.getItem("authToken")
}
}
